import React, { FunctionComponent } from 'react'
import LoadingIcon from '@assets/images/icons/loader.gif';

import './AppLoader.scss'

function AppLoader() {
  return (
    <div className="container">
      <img alt="loader" src={LoadingIcon} />
    </div>
  )
}

export default AppLoader
